module.exports = __webpack_public_path__ + "img/ivory-coast.574fe64b.svg";